import { useGetSearchExamQSetUsageRecordsQuery } from '@report/graphql';
import { Button, FileUploadOutlinedIcon } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { dayjs } from '@shared/utils';

import { useQSetUsageReportSearchParams } from '../../hooks';
import QSetUsageReportExportModal from '../qset-usage-report-export-modal/qset-usage-report-export-modal';

export default function QSetUsageReportExportButton() {
  const [isModalOpen, { open: openModal, close: closeModal }] = useDisclosure();
  const [{ examStartDate, examEndDate, examCourseId, page, pageSize }] =
    useQSetUsageReportSearchParams();
  const isSearchEmpty = !examStartDate || !examEndDate || !examCourseId;

  const { data: qSetUsageData } = useGetSearchExamQSetUsageRecordsQuery({
    variables: {
      searchExamQSetUsageRecordsInput: {
        paging: {
          pageSize,
          currentPage: page,
        },
        filter: {
          startedAt: (examStartDate ? dayjs(examStartDate).startOf('day').toDate() : null) as Date,
          endedAt: (examEndDate ? dayjs(examEndDate).endOf('day').toDate() : null) as Date,
          examCourseId: examCourseId as string,
        },
      },
    },
    skip: isSearchEmpty,
  });

  const totalCount = qSetUsageData?.reportSearchExamQSetUsageRecords?.total ?? 0;
  const shouldDisable = totalCount === 0;

  const handleClick = () => {
    openModal();
  };

  return (
    <>
      <Button
        variant='outlined'
        color='secondary'
        startIcon={<FileUploadOutlinedIcon />}
        onClick={handleClick}
        disabled={shouldDisable}
      >
        Export
      </Button>
      <QSetUsageReportExportModal open={isModalOpen} onClose={closeModal} totalCount={totalCount} />
    </>
  );
}
